export enum UserRoles {
  ADMIN,
  USER,
}

export const COORDINATOR_JOB = "coordinators";
